<template>
    <div class="stat-card">
      <h3>{{ $t('randevu.stats.total_card.title') }}</h3>
      <p v-if="total !== null">{{ total }}</p>
      <p v-else>{{ $t('common.loading') }}</p>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'TotalAppointmentsCard',
    data() { return { total: null }; },
    async created() {
      try {
        const { data } = await axios.get('/promo/user/stats/total-appointments');
        this.total = data.total;
      } catch (err) { console.error('Veri alınamadı:', err); }
    }
  };
  </script>
  
  <style scoped>
  .stat-card {
    padding: 1rem; 
    border-radius: 6px;
    text-align: center;
    background-color: #050505;  
    margin-top: 1em;
  }
  
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1rem; 
    font-weight: 400;
  }
  
  p {
    font-size: 1.5rem;
    font-weight: 300;
    color: #1cc655; 
    padding: 0;
    margin: 0;
  } 
  </style>
  